let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8GD7m")).then(() => parcelRequire('8R0uH'));